export const MODULE_NAME = `calendar`

export const addModulePrefix = constantString =>
  `${MODULE_NAME}/${constantString}`

// Request status constants
export const INITIAL = {
  initial: true,
  pending: false,
  completed: false,
  failed: false,
}

export const PENDING = {
  initial: false,
  pending: true,
  completed: false,
  failed: false,
}

export const COMPLETED = {
  initial: false,
  pending: false,
  completed: true,
  failed: false,
}

export const FAILED = {
  initial: false,
  pending: false,
  completed: false,
  failed: true,
}
